
class FloatingDuoBtn extends HTMLElement {
  static VISIBLE_CLASS = 'floating-duo-btn--visible';
  static TRIGGER_OFFSET = 30; 
  static PURCHASE_FLOW_SELECTOR = '.product__info-container';

  connectedCallback() {
    this.btn = this.querySelector('.floating-duo-btn');
    if (!this.btn) return;

    // Optional merchant-set delay (ms) between the reveal condition and the button
    // actually appearing (Theme settings → Floating chat button → Show delay).
    this.showDelay = Number(this.btn.dataset.showDelay) || 0;
    this._delayDone = false;
    this._delayTimer = null;

    const purchaseFlow = document.querySelector(FloatingDuoBtn.PURCHASE_FLOW_SELECTOR);

    if (purchaseFlow && 'IntersectionObserver' in window) {

      this._io = new IntersectionObserver(
        ([entry]) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this._setVisible(scrolledPast);
        },
        { threshold: 0 },
      );
      this._io.observe(purchaseFlow);
      return;
    }

  
    this._rafId = 0;
    this._onScroll = this._onScroll.bind(this);
    window.addEventListener('scroll', this._onScroll, { passive: true });
    this._onScroll();
  }

  disconnectedCallback() {
    this._io?.disconnect();
    if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
    if (this._rafId) {
      cancelAnimationFrame(this._rafId);
      this._rafId = 0;
    }
  }

  _onScroll() {
  
    if (this._rafId) return;
    this._rafId = requestAnimationFrame(() => {
      this._rafId = 0;
      this._setVisible(window.scrollY > FloatingDuoBtn.TRIGGER_OFFSET);
    });
  }

  _setVisible(visible) {
    if (this.showDelay && !this._delayDone) {
      if (visible) {
        // Start (or keep) the delay countdown; reveal only when it completes.
        if (!this._delayTimer) {
          this._delayTimer = setTimeout(() => {
            this._delayDone = true;
            this._delayTimer = null;
            this.btn?.classList.add(FloatingDuoBtn.VISIBLE_CLASS);
          }, this.showDelay);
        }
      } else if (this._delayTimer) {
        // Reveal condition ended before the delay elapsed — cancel, start fresh next time.
        clearTimeout(this._delayTimer);
        this._delayTimer = null;
      }
      return;
    }
    this.btn?.classList.toggle(FloatingDuoBtn.VISIBLE_CLASS, visible);
  }
}

if (!customElements.get('floating-duo-btn')) {
  customElements.define('floating-duo-btn', FloatingDuoBtn);
}
